export default __webpack_public_path__ + "static/Oliver-fcf78f4c1d88ab5349032af27de4e377fd2929ba3848c3fce1309a1957f87437.svg";